import { TabCard, TabProps } from 'components';
import { SafetyCertificateOutlined, SettingOutlined, HistoryOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import MaintenanceTable from './maintenance/Table';
import TestsTable from './test/Table';
import NewMaintenance from './maintenance/CreateButton';
import { Tool, ToolMaintenance, ToolProject, ToolTest } from 'app/types/tool';
import NewToolTest from './test/CreateButton';
import HistoryTable from './history/Table';

type TabsProps = {
  // Full private Tool - required to render the create-new actions. Omit it (and pass
  // readonly + the *bundled* data below) for the public, unauthenticated overview page.
  tool?: Tool;
  readonly?: boolean;
  maintenances?: ToolMaintenance[];
  tests?: ToolTest[];
  projects?: ToolProject[];
};

const Tabs = ({ tool, readonly, maintenances, tests, projects }: TabsProps) => {
  const { t } = useTranslation();
  const tabs: TabProps[] = [];

  tabs.push(
    {
      key: 'maintenance',
      title: t('tabs.maintenance'),
      icon: <SettingOutlined />,
      content: <MaintenanceTable tool={tool} data={maintenances} readonly={readonly} />,
      actions: tool ? <NewMaintenance tool={tool}/> : undefined,
    },
    {
      key: 'tests',
      title: t('tabs.tests'),
      icon: <SafetyCertificateOutlined />,
      content: <TestsTable tool={tool} data={tests} readonly={readonly} />,
      actions: tool ? <NewToolTest tool={tool} /> : undefined,
    },
    {
      key: 'history',
      title: t('tabs.history'),
      icon: <HistoryOutlined />,
      content: <HistoryTable tool={tool} data={projects} />,
    },

  );

  return <TabCard tabs={tabs} />;
};

export default Tabs;